import { render, staticRenderFns } from "./UploadAvatarComponent.vue?vue&type=template&id=c9f2fc12"
import script from "./UploadAvatarComponent.vue?vue&type=script&lang=js"
export * from "./UploadAvatarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports